import { BasicNode, Mapping, RendererProps } from './types';

export const marks: Mapping = {
  bold: ({
    editor: _,
    node: { attrs },
    children,
  }: RendererProps<BasicNode>) => <b {...attrs}>{children}</b>,
  italic: ({
    editor: _,
    node: { attrs },
    children,
  }: RendererProps<BasicNode>) => <em {...attrs}>{children}</em>,
  link: ({
    editor: _,
    node: { attrs },
    children,
  }: RendererProps<BasicNode>) => (
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    <a {...attrs} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  ),
  code: ({
    editor: _,
    node: { attrs },
    children,
  }: RendererProps<BasicNode>) => <code {...attrs}>{children}</code>,
  underline: ({
    editor: _,
    node: { attrs },
    children,
  }: RendererProps<BasicNode>) => <u {...attrs}>{children}</u>,
  textStyle: ({
    editor: _,
    node: { attrs },
    children,
  }: RendererProps<BasicNode>) => <span style={{ ...attrs }}>{children}</span>,
  highlight({ node: { attrs }, children }: RendererProps<BasicNode>) {
    return <span style={{ background: String(attrs?.color) }}>{children}</span>;
  },
};
